import { InventoryItem } from '../data/inventory'
import { ListingCardProps } from '../components/ListingCard'
// Collapse to lowercase alphanumerics so "rangerover" matches "Range Rover Sport 2021".
const normalize = (value: string) =>
  value.toLowerCase().replace(/[^a-z0-9]/g, '')
export function searchInventory(
  items: InventoryItem[],
  query: string,
): InventoryItem[] {
  const q = normalize(query)
  if (!q) return items
  return items.filter((item) =>
    normalize(`${item.title} ${item.category} ${item.status}`).includes(q),
  )
}
// Present an inventory item exactly as buyers see listings on Discover.
export function toListingCard(item: InventoryItem): ListingCardProps {
  return {
    id: item.id,
    title: item.title,
    price: item.price,
    location: item.location,
    images: item.images,
    specs: item.specs,
    matchScore: item.aiScore,
    sellerType: 'Verified Business',
  }
}
